var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "RoomPage",
      attrs: { id: "app" },
      on: {
        click: _vm.OnAppClick,
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.OnAppEscape($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "MobileMenuContainer ",
          class: {
            FirstSelected: this.SelectedIndex == 0,
            Fixed: this.MobileMenuFixed
          }
        },
        [
          _c("BlockPaging", {
            ref: "MobileMenuBlockPaging",
            staticClass: "MobileMenuItemList OnlyMobile",
            on: { ItemClick: _vm.OnMobileMenuItemClick },
            model: {
              value: _vm.MobileMenuItemListData,
              callback: function($$v) {
                _vm.MobileMenuItemListData = $$v
              },
              expression: "MobileMenuItemListData"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.Rooms, function(room, index) {
        return _c("div", { staticClass: "Room" }, [
          _c(
            "div",
            { class: ["Room_" + index] },
            [
              _c("A", { attrs: { name: "Room_" + index } }),
              _vm._v(" "),
              _c("div", { staticClass: "RoomMenuContainer" }, [
                _c(
                  "div",
                  { staticClass: "RoomMenu OnlyDesktop" },
                  _vm._l(_vm.Rooms, function(r, i) {
                    return _c(
                      "A",
                      {
                        staticClass: "RoomMenuItem",
                        class: { Focus: i == index },
                        attrs: { href: "#Room_" + i },
                        on: {
                          click: function($event) {
                            return _vm.OnRoomMenuItemClick(r, i)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "RoomIconContainer" }, [
                          _c("div", {
                            staticClass: "RoomIcon",
                            style: { backgroundColor: r.IconColor }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "RoomTileContaier" }, [
                          _c("div", { staticClass: "RoomTitle" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(r.Title) +
                                "\n                            "
                            )
                          ])
                        ])
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "MapPictureGroup" }, [
                  _c("div", {
                    staticClass: "PictureContainer Map Contain",
                    style: {
                      backgroundImage: "url(" + room.MapPicturePath + ")"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              room.BackgroundPicturePath != null
                ? _c(
                    "div",
                    {
                      staticClass: "RoomMainContainer",
                      style: {
                        backgroundImage:
                          "url(" + room.BackgroundPicturePath + ")"
                      }
                    },
                    [
                      _c("div", [
                        _c("img", {
                          staticClass: "BackgroundPicturePath",
                          attrs: { src: room.BackgroundPicturePath }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            on: { click: _vm.OnRoomPictureListContainerClick }
                          },
                          [
                            _c("BlockPaging", {
                              staticClass: "RoomPictureList",
                              attrs: { value: room.PictureListData },
                              on: { ItemClick: _vm.OnRoomPictureClick }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }